export default __webpack_public_path__ + "static/media/sip.28131149.svg";